import React from 'react';
import OpcionDefecto from '../../../../../Common/Components/OpcionDefecto'
import CheckDefecto from "../../../../../Common/Components/CheckDefecto";

const LineasPrestamo = ({ data, selectCheckBox, selectCombo }) => {
    const { GET_LINEA_PRESTAMO, ERROR_PRODUCT, GET_PARAMETRO_GENERAL } = data;
    const arrayAux = GET_LINEA_PRESTAMO.filter(d => d.Checked);
    
    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                {GET_PARAMETRO_GENERAL.SINOLINEAPRESTAMOS && <label className="label-primary">{"L\u00EDneas de pr\u00E9stamo"}</label>}

                {GET_PARAMETRO_GENERAL.SINOLINEAPRESTAMOS && GET_LINEA_PRESTAMO.map((item) => {
                    const referencia = `GLP-${item.Id}`;

                    return (
                        ((item.AdministradoraIr==1&&item.Activo) || item.noDisponible) && <CheckDefecto
                            key={item.Id}
                            nombre={item.Descripcion}
                            check={item.Checked}
                            activo={item.Activo}
                            referencia={referencia}
                            selectCheckBox={() => selectCheckBox("GET_LINEA_PRESTAMO", item.Id)} />
                    )
                })}

                {GET_PARAMETRO_GENERAL.SINOLINEAPRESTAMOS && <OpcionDefecto
                    selecciono={arrayAux.length}    
                    infoData={arrayAux}
                    referencia={"LimitePrestamoDefaultId"}
                    valorCombo={data.LimitePrestamoDefaultId}
                    valorChecked={data.LimitePrestamoDefaultInterfaz}
                    selectCombo={(value) => selectCombo("LimitePrestamoDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("LimitePrestamoDefaultInterfaz", value)}
                />}

                {(!ERROR_PRODUCT["seleccionoLineaPrestamo"] && arrayAux.length==0) &&
                    <label className="error">{"Debe seleccionar al menos una l\u00EDnea de prestamo."}</label>}
            </div>
        </div>
    );
}

export default LineasPrestamo;